export const STATUS_SEPARATOR = "::STATUS::";

export const STATUS_CONFIG = [
	{ key: "approved" as const, id: "APPROVED", labelKey: "approved", color: "#4caf50" },
	{ key: "pending" as const, id: "PENDING", labelKey: "pending", color: "#f9a825" },
	{ key: "open" as const, id: "OPEN", labelKey: "open", color: "#2196f3" },
	{ key: "left" as const, id: "LEFT", labelKey: "left", color: "#9e9e9e" },
] as const;

export const STATUS_COLORS: Record<string, string> = {
	APPROVED: "#4caf50",
	PENDING: "#f9a825",
	OPEN: "#2196f3",
	LEFT: "#9e9e9e",
};

export type StatusKey = (typeof STATUS_CONFIG)[number]["key"];
export type StatusId = (typeof STATUS_CONFIG)[number]["id"];

export type PositionSummary = {
	id: string;
	projectName: string;
	positionName: string;
	totalMinutes: number;
	totalWorkedMinutes: number;
	leftMinutes: number;
	statusMinutes: {
		approved: number;
		pending: number;
		open: number;
	};
};

export type ChartData = {
	id: string;
	labelValue?: string;
	label: string;
	value: number;
	percentage: number;
	color: string;
};

export type PieChartItem = ChartData & {
	percentage: number;
};

export type ProjectProgressTotals = {
	totalMinutes: number;
	totalWorkedMinutes: number;
	totalLeft: number;
	formatted: {
		total: string;
		totalWorked: string;
	};
};
